'use client';

import { c as _c } from "react/compiler-runtime";
import { Transition } from '@headlessui/react';
import { type CustomerReviewItem } from '@src/components/CustomerReviews/CustomerReviews.props';
import { StarRating } from '@src/components/CustomerReviews/StarRating';
export const CustomerReviewCard = props => {
  const $ = _c(19);
  const {
    content,
    name,
    product,
    ratingOutOfFive,
    shouldAnimate,
    color
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      boxShadow: "0px 8px 16px 0px #1618190D"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== name) {
    t1 = <div className="font-medium">{name}</div>;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = product ?? "";
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="text-body-xs text-bodi-gray-medium" dangerouslySetInnerHTML={{
      __html: t2
    }} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="my-4 h-px bg-bodi-gray-light" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = ratingOutOfFive ?? 0;
  let t6;
  if ($[6] !== color || $[7] !== t5) {
    t6 = <div className="mb-2"><StarRating color={color} ratingOutOfFive={t5} /></div>;
    $[6] = color;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = content ?? "";
  let t8;
  if ($[9] !== t7) {
    t8 = <div className="prose" dangerouslySetInnerHTML={{
      __html: t7
    }} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t6 || $[14] !== t8) {
    t9 = <div style={t0} className={"\n          relative rounded-3xl bg-bodi-white p-8 text-bodi-black-text\n          transition duration-300 ease-in data-closed:opacity-0"}>{t1}{t3}{t4}{t6}{t8}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== shouldAnimate || $[17] !== t9) {
    t10 = <Transition show={true} appear={shouldAnimate}>{t9}</Transition>;
    $[16] = shouldAnimate;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};